import * as React from 'react';

const HeaderLayoutCenter = (props) => {
  return (
    <div className="m__head__cent">
      {props.children}
    </div>
  )
};

export default HeaderLayoutCenter;
